@if (details$ | async; as details) {
  <div class="mx-auto flex max-w-screen-xl flex-col gap-8">
    <app-admin-brand-banner-preview
      [brandId]="details.id"
      [reloadVersion]="0" />

    <app-brand-details
      [name]="details.name"
      [description]="details.description"
      [homeUrl]="details.homeUrl"
      [illustrationAlt]="details.illustrationAlt"
      [illustrationSrc]="details.illustrationSrc"
      [socials]="details.socials"
      [shouldShowStatusInfo]="true"
      [isPrivate]="details.isPrivate()"
      [isPublic]="details.isPublic()"
      [isDraft]="details.isDraft()"
      [shouldShowEditButton]="details.canBeEdited"
      (editClickEvent)="handleEditClickEvent()" />
  </div>
} @else {
  <app-spinner-filled />
}
